
const AdminHomeUI = (props) => {
	
  return (
  <>

  </>
  );
};

export default AdminHomeUI;